import {createFileRoute} from '@tanstack/react-router';
import ClubOverview from '../../../../clubs/dashboard/ClubOverview';

// Communities are clubs of type Community — the overview shell is shared, the uid param differs.
export const Route = createFileRoute('/_app/communities/$community_uid/overview')({
    component: () => {
        const {community_uid} = Route.useParams();
        return <ClubOverview clubUid={community_uid} />;
    },
});
